  
    <template>
   
   <div>
       <Header/>

   
<!--End mainmenu area--> 

<!--Start breadcrumb area-->

<section class="breadcrumb-area" v-bind:style="{backgroundImage: 'url('+this.pagebanner+ ')' }">
	<div class="container text-center">
		<h1>FAQ</h1>
		<span class="border"></span>
	</div>
</section>
<!--End breadcrumb area-->
         
<!--Start breadcrumb bottom area--> 
<section class="breadcrumb-bottom-area">
    <div class="container">
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <a href="#"></a>    
        </div>
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <ul>
               <li><a :href="$i18n.locale == 'en' ? '../../../../en/': '../../../../ar/'">{{ $i18n.locale == 'en' ? 'Home':'الرئيسية' }}</a></li>
               <li>></li>
                <li><a href="#">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</a></li>
                
            </ul>    
        </div>        
    </div>    
</section>         
<!--End breadcrumb bottom area-->
         
<!--Start faq content area-->
<section class="faq-content-area">
    <div class="container">
        <div class="row">
                <div class="faq-content-holder">
                    <div class="top">
                        <div :class="$i18n.locale=='en'?'title pull-left':'title pull-right'" :style="$i18n.locale=='en'?'text-align: left!important':'text-align: right!important'">
                            <div class="sec-title two">
                                <h1 :style="$i18n.locale=='en'?'text-align: left!important':'text-align: right!important'">{{$i18n.locale == 'en' ? pagedata.en_subtitle:pagedata.ar_subtitle}}</h1>
                            </div>
                        </div>
                        <div class="search-question pull-right">
                            <form class="search-question-form" action="#">
                            </form>
                        </div>
                    </div>
                   <div class="text-holder" :dir="$i18n.locale=='en'?'ltr!important':'rtl!important'" v-html="$i18n.locale == 'en' ? pagedata.pagecontenten:pagedata.pagecontentar" :style="$i18n.locale=='en'?'text-align: left!important':'text-align: right!important'">
                       {{$i18n.locale == 'en' ? pagedata.pagecontenten:pagedata.pagecontentar}}
                    </div>
                    <div class="faq-content">
                        <div class="accordion-box">
                            <!--Start single accordion box-->
                            <div class="accordion accordion-block" v-for="faqlist in faq" v-bind:key="faqlist.id">
                                <div class="accord-btn"><h4 :dir="$i18n.locale=='en'?'ltr!important':'rtl!important'" :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'"> {{ $i18n.locale == 'en' ? faqlist.questionen: faqlist.questionar }}</h4></div>
                                <div class="accord-content">
                                    <p :dir="$i18n.locale=='en'?'ltr!important':'rtl!important'" v-html="$i18n.locale == 'en' ? faqlist.answeren:faqlist.answerar"> {{ $i18n.locale == 'en' ? faqlist.answeren: faqlist.answerar  }}</p>
                                </div>
                            </div>
                            
                    </div>                 
                </div>    
            <div class="col-lg-3 col-md-4 col-sm-7 col-xs-12 pull-left">
                <div class="about-sidebar">
                    <!--End single sidebar--> 
                </div>
            </div>
                </div>
        </div>
    </div>
</section>
   <!--End faq content area-->
	<!--Start slogan area-->
<section class="slogan-area">
    <div class="container">
        <div class="title pull-center">
            <h2>{{ $i18n.locale == 'en' ? pagefooteren: pagefooterar  }}</h2>    
        </div>
        <div class="buttons pull-right">
        </div>
    </div>    
</section>
<!--End slogan area-->
<!--Start footer area-->  
            <Footer/>

    </div>
    </div>

</template>


<script>
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery-1.11.1.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.bxslider.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.countTo.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.appear.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/owl.carousel.min.js";

import  "https://wafrafrontend.marketequityinc.com/src/assets/js/validate.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.mixitup.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.easing.min.js";
import "http://maps.google.com/maps/api/js?sensor=true";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/fancyapps-fancyBox/source/jquery.fancybox.pack.js";		

import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.tools.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.revolution.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.actions.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.carousel.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.kenburn.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.layeranimation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.migration.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.navigation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.parallax.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.slideanims.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.video.min.js";




import "https://wafrafrontend.marketequityinc.com/src/assets/js/custom.js";
</script>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'Home',
    title: 'Home',
    data() {
        return {
            langs: ['en', 'ar'],
           
            homepageblocks: '',
            homeblock1: null,
            homeblockimage1: null,
            homepageblocksicons: [],
            homepageblocksicons3: [],
            homepageblocks2: '',
            ceomessage: '',
            successstories: '',
            slide1image:'',
            slide2image:'',
            slide3image:'',
            faq:'',
            pagedata:'',
            pagebanner:'',
            pagefooteren:'',
            pagefooterar:''

        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {
          var pathvalues = (this.$route.path).split("/");
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'ar';
        }
       
        this.loadfaq();
                        this.loaddata();

      
        this.loadpagedata('faq');

    },
    mounted() {
        
        this.faq();

        this.loadpagedata('faq');
        this.loaddata();
       
    },

    methods: {
          loaddata() {

            this.$axios.get("loadheaderdata",
            )
                .then(res => {
                    if (res) {

                       
                        this.pagefooteren = res.data.sitesettings[0].pagefooteren;
                        this.pagefooterar = res.data.sitesettings[0].pagefooterar;
                      
                    }
                });
        },
 
       loadfaq() {

            this.$axios.get("loadfaq",
            )
                .then(res => {
                    if (res) {

                        this.faq = res.data.faqdata;

                    }
                });
        },
       loadpagedata(pagename) {
            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                          if (res.data.code == 200) {
                        this.pagedata = res.data.pagedata[0];
                        this.pagebanner=this.serverurl+'/public/pagebanners/'+res.data.pagedata[0].pagebanner;
                          }
                        else{

                            this.$router.push({ name: 'NotFound' })
                        }
                    }
                });
            

        },

    }
}
</script>
<style>
#div1::after{
    clear: none!important;
    
}
.carousel {
  background: #2f435700!important;
}
    
</style>
